import { useEffect, useLayoutEffect, useRef } from "react";

export default function useDetectOutsideClick(cb, ...refs) {
  const initialisedRef = useRef(false);
  useEffect(() => {
    setTimeout(() => (initialisedRef.current = true), 100);
    const body = document.getElementsByTagName("body")[0];
    const handler = (event) => {
      if (!initialisedRef.current) return;
      const isOutsideClick = !hasElementInPath(event, ...refs);
      isOutsideClick && cb && cb();
    };

    const eventNames = ["click", "touchstart", "touchend"];
    eventNames.forEach((evt) => body.addEventListener(evt, handler));
    return () => {
      eventNames.forEach((evt) => body.removeEventListener(evt, handler));
    };
  }, [cb, refs]);
}

function hasElementInPath(evt, ...refs) {
  if (evt.path) {
    return evt.path.some((x) => refs.some((r) => x === r.current));
  }
  let current = evt.target;
  // safari doesnt have a path list
  while (current) {
    // eslint-disable-next-line no-loop-func
    if (refs.some((r) => r.current === current)) return true;
    current = current.parentElement;
  }
  return false;
}
